@if (validationErrors) {
    <div class="errors">
        <p>
            <span appIcon="warning-circle"
                  class="warning-icon"
            ></span>

            {{ validationErrors.length ? ('validation.check-inputs' | translate) : ('graphql-errors.something-went-wrong' | translate) }}
        </p>

        @if (validationErrors.length) {
            <ul>
                @for (item of validationErrors; track item) {
                <li>
                    {{ item }}
                </li>
                }
            </ul>
        }
    </div>
}

@if (defaultError) {
    <div class="errors">
        <p>
            <span appIcon="warning-circle"
                  class="warning-icon"
            ></span>

            {{ 'register.something-went-wrong' | translate }}
        </p>
    </div>
}
